import type { RollSource } from './roll-source.js';

/** CampaignHouseRuleType identities and log labels, check_critical_hit_logic.php. */
export const CRIT_CASCADE_RULES = {
  remarkable: { id: '6C85D904-D3AE-5680-666F-5FC49A4FFF4D', name: 'Critical Hits: Improved Damage - Remarkable (20 x 2)', rollType: 'remarkable_crit_trigger_d20', bonusLabel: 'Remarkable Critical Damage' },
  worldShaking: { id: '71221E94-E2E8-EF30-EE0E-8E4C53860250', name: 'Critical Hits: Improved Damage - World-shaking (20 x 3)', rollType: 'world_shaking_crit_trigger_d20', bonusLabel: 'World Shaking Critical Damage' },
  maimed: { id: 'FFFE4F7F-0018-4961-5BB9-2B69268CD48E', name: 'Critical Hits: Maimed' },
} as const;
export interface CritCascadeRules { remarkable: boolean; worldShaking: boolean; maimed: boolean }
export interface CritCascadeTrigger { rule: 'remarkable' | 'worldShaking'; face: number; bonus: number }

/** First damage fragment only. Both riders stay pinned at maximum under every base crit model. */
export function resolveCritCascades(roll: RollSource, rules: CritCascadeRules, dice: number, die: number): CritCascadeTrigger[] {
  if (!rules.remarkable) return [];
  const face = roll.d(20);
  const triggers: CritCascadeTrigger[] = [{ rule: 'remarkable', face, bonus: face === 20 ? dice * die : 0 }];
  if (face === 20 && rules.worldShaking) {
    const world = roll.d(20);
    triggers.push({ rule: 'worldShaking', face: world, bonus: world === 20 ? dice * die : 0 });
  }
  return triggers;
}
